import React from 'react'
import iconPhoneCircle from './icon_phone_circle.svg'
import iconExternalLinkCircle from './icon_external_link_circle.svg'
import './ClinicContactInfo.scss'

const ClinicContactInfo = ({ clinic, visitWebsiteText }) => {
  return (
    <div
      className="ClinicContactInfo no-external-link-styling"
      onClick={(e) => e.stopPropagation()}
      role="presentation"
    >
      {clinic.formatted_phone && (
        <a href={`tel:${clinic.formatted_phone}`}>
          <img src={iconPhoneCircle} alt="clinic phone" />
          {clinic.formatted_phone}
        </a>
      )}

      {clinic.url && (
        <a href={clinic.url} target="_blank" rel="noopener noreferrer">
          <img src={iconExternalLinkCircle} alt="" />
          {visitWebsiteText}
        </a>
      )}
    </div>
  )
}

export default ClinicContactInfo
